import React, { useState, useEffect } from "react";
import { getUsers, createUser, updateUser, deleteUser } from "../services/api";
import { Table, TableHead, TableRow, TableCell, TableBody, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { toast } from "react-toastify";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentUser, setCurrentUser] = useState({ userId: "", userName: "", password: "", role: "", orgId: "", orgName: "", email:"",phone:"" });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await getUsers();
      setUsers(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenModal = (user = null) => {
    if (user) {
      setCurrentUser(user);
      setEditMode(true);
    } else {
      setCurrentUser({ userId: "", userName: "", password: "", role: "", orgId: "", orgName: "",email:"",phone:"" });
      setEditMode(false);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveUser = async () => {
    try {
      if (editMode) {
        await updateUser(currentUser.userId, currentUser);
        toast.success("User updated successfully");
      } else {
        await createUser(currentUser);
        toast.success("User created successfully");
      }
      fetchUsers();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save user");
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      await deleteUser(id);
      toast.success("User deleted successfully");
      fetchUsers();
    } catch (error) {
      toast.error("Failed to delete user");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>User Management</h2>
      <Button variant="contained" color="primary" onClick={() => handleOpenModal()}>
        Add User
      </Button>

      <Table style={{ marginTop: 20 }}>
        <TableHead>
          <TableRow>
            <TableCell>User ID</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone No</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.userId}>
              <TableCell>{user.userId}</TableCell>
              <TableCell>{user.userName}</TableCell>
              <TableCell>{user.role}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.phone}</TableCell>
              <TableCell>
                <Button variant="contained" color="secondary" onClick={() => handleDeleteUser(user.userId)} style={{ marginRight: 10 }}>
                  Delete
                </Button>
                <Button variant="contained" color="primary" onClick={() => handleOpenModal(user)}>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* User Modal */}
      <Dialog open={openModal} onClose={handleCloseModal}  PaperProps={{
            sx: {
              width: "450px",
              margin: "auto", // Ensures the dialog stays centered
              borderRadius: "8px"
            },
          }}>
        <DialogTitle>{editMode ? "Edit User" : "Add User"}</DialogTitle>
        <DialogContent>
          <TextField
            label="User ID"
            value={currentUser.userId}
            onChange={(e) => setCurrentUser({ ...currentUser, userId: e.target.value })}
            fullWidth
            margin="dense"
            disabled={editMode}
            size="small"
          />
          <TextField
            label="Username"
            value={currentUser.userName}
            onChange={(e) => setCurrentUser({ ...currentUser, userName: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Password"
            type="password"
            value={currentUser.password}
            onChange={(e) => setCurrentUser({ ...currentUser, password: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Role"
            value={currentUser.role}
            onChange={(e) => {
              const lowercaseValue = e.target.value.toLowerCase(); // Convert input to lowercase
              setCurrentUser({ ...currentUser, role: lowercaseValue });
            }}
            fullWidth
            margin="dense"
            size="small"
          />

          <TextField
            label="Org ID"
            value={currentUser.orgId}
            onChange={(e) => setCurrentUser({ ...currentUser, orgId: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Org Name"
            value={currentUser.orgName}
            onChange={(e) => setCurrentUser({ ...currentUser, orgName: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Email"
            value={currentUser.email}
            onChange={(e) => setCurrentUser({ ...currentUser, eamil: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Phone"
            value={currentUser.phone}
            onChange={(e) => setCurrentUser({ ...currentUser, phone: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
        </DialogContent>
        <DialogActions sx={{margin:"0px 17px 10px 0px"}}>
          <Button onClick={handleCloseModal} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSaveUser} color="primary" variant="contained">
            {editMode ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserManagement;
